import MobileDetect from 'mobile-detect';

export function detect() {
  let ieDetect = false;
  let mobileDetect = false;
  const htmlT = $('html');
  const windowT = $(window);
  const ua = window.navigator.userAgent;
  const old_ie = ua.indexOf('MSIE ');
  const new_ie = ua.indexOf('Trident/');
  const md = new MobileDetect(ua);

  if (md.mobile()) {
    mobileDetect = true;
    htmlT.addClass('mobile');
  } else {
    htmlT.addClass('no-mobile');
  }

  //IE Detect
  if ((old_ie > -1) || (new_ie > -1)) {
    ieDetect = true;
  }

  return {
    htmlT,
    windowT,
    ieDetect,
    mobileDetect,
  }
}
